angular.module('galilai.creator').controller('CalendarController', function($scope, $interval, $timeout, $rootScope, $http, api, layoutService, parserService, animator, topics) {
    console.log('CalendarController');

    const MAX_SAMPLE = 4
    const MAX_SAMPLE_TOPICS_FOR_GENERATION = 10
    const DEFAULT_IMAGE_TYPE = 'any'
    const ADD_ILLUSTATION = true
    const OPEN_EXTERNAL_EDIT = true
    let itemsGenerated = 0

    $scope.view = {
        // TODO - hardcoded
        specialDatesEnabled: getCurrentLanguage() == 'pt',
        currentMonth: new Date().getMonth() + 1,
        currentYear: new Date().getFullYear(),
        currentMonthName: '',
        currentPost: null,
        currentEditPostIndex: 0,
        showPlanning: false,
        removeDropdown: {},
        settingsDropdown: {},
        loadingGenerate: {},
        choosingTopic: false,
        currentGenerateDay: null,
        loading: {
            savingReplan: false,
        },
        errors: {
            reauthRequired: false,
            instagramBusiness: false,
            rateLimit: false,
            userRestricted: false,
        },
        animators: [],
        addIllustration: ADD_ILLUSTATION,
    }
    $scope.expandedLayouts = []
    $scope.layoutsConfig = {}
    $scope.parsedPosts = []
    $scope.posts = []
    $scope.items = []

    let viewData = {
        specialDates: null
    }

    const mapTimes = {
        'morning': ['09:00', '10:00', '11:00'],
        'afternoon': ['13:00', '14:00', '15:00'],
        'morning-afternoon': ['09:00', '10:00', '11:00', '13:00', '14:00', '15:00'],
        'night': ['18:00', '19:00', '20:00'],
    }

    const defaultSchedule = {
        when: 'weekdays',
        time: 'morning-afternoon',
        where: 'instagram',
        what: 'post+story+reels',
        topicFilter: 'all',
    }
    const validPostTypes = ['post', 'story', 'reels', 'post+story', 'post+reels', 'story+reels', 'post+story+reels']

    $scope.calendar = {
        availableTopics: [],
        selectedTopics: [],
        topics: [],
        currentGenerateDay: null,
        edit: {
            url: null,
        },
        schedule: Object.assign({}, defaultSchedule),
        weeks: []
    }

    const mapScheduleToDays = {
        everyday: [0, 1, 2, 3, 4, 5, 6],
        weekdays: [1, 2, 3, 4, 5],
        mwf: [1, 3, 5],
        mtutws: [1, 2, 4, 6],
        weekends: [0, 6],
    }

    function getContentLanguage() {
        if ($scope.state && $scope.state.data && $scope.state.data.global && $scope.state.data.global.config && $scope.state.data.global.config.language) {
            return $scope.state.data.global.config.language
        }
        return null
    }

    window.addEventListener('storage', (event) => {
        if (event.key === 'galilai.posts.schedule.update') {
            try {
                if (event.newValue) {
                    let data = JSON.parse(event.newValue)
                    if (data && data.name == 'postScheduleUpdated') {
                        $scope.processEditMessages({data: data})
                    }
                }
            } catch (e) {
                console.log('Error processing storage event', e)
            }
        }
    });

    $scope.$watch('inputs.project', function() {
        if (!$scope.inputs.project) {
            return
        }
        $scope.onProjectChanged()
    })

    $rootScope.$on('calendarReload', function(event, project) {
        $rootScope.$broadcast('clearPosts')
        $scope.fetchCalendar()
    })

    $rootScope.$on('projectLoaded', function(event, project) {
        console.log('=> Project loaded', project)
        $scope.loadCalendarConfig()
        // TODO - Refactor to use topics service
        $scope.getTopics()
        topics.init(project, {
            language: getContentLanguage(),
        })
    })

    $rootScope.$on('generator.onNewPosts', function(event, data) {
        if (!data || data.source != 'calendar') {
            return
        }
        onNewPosts(data.posts)
    })

    $rootScope.$on('generateInitialCalendar', function(event, project) {
        console.log('=> Generate initial calendar')

        if ($scope.preventGenerateLoggedOut()) {
            return
        }
        $scope.changeViewModeCalendar()

        $rootScope.loading.calendar = true

        $scope.getTopics(function(err) {
            $rootScope.loading.calendar = false
            if (err) {
                showError(gettext('error.calendar_no_topics'))
                return
            }
            $scope.generateCalendar('auto')
        })
        if (window.innerWidth < 768) {
            $timeout(function() {
                let header = document.getElementById('calendar-header')
                if (header) {
                    header.scrollIntoView()
                }
            })
        }
    })

    // Only needed after dynamic item
    $scope.$on('calendarItemChanged', function(event, data) {
        let fullLayout = null
        let layout = null
        try {
            if (data.changes && data.changes.fullLayout) {
                fullLayout = data.changes.fullLayout
                data.changes.layout = fullLayout.id
                layout = fullLayout.data
                if (!$scope.items[data.id].meta) {
                    $scope.items[data.id].meta = {}
                }
                $scope.items[data.id].meta.layout = fullLayout.id
            }
        } catch (e) {
            console.log(e)
            logError({
                message: 'Error updating layout',
                error: e,
            })
        }
        $scope.items[data.id] = Object.assign($scope.items[data.id], data.changes)
        // TODO - Bug?? No passing layout
        $scope.parsedPosts[data.id] = $scope.parsePost($scope.items[data.id], layout, null, data.id)
        $timeout(angular.noop)
    })

    function getContentForItem(item, itemConfig, index) {
        let base = {}
        if (itemConfig && itemConfig.global && itemConfig.global.content) {
            base = Object.assign({}, itemConfig.global.content)
        }
        item = Object.assign(JSON.parse(JSON.stringify(base)), item)
        if (itemConfig.images && itemConfig.images.hasOwnProperty(index)) {
            item.image = itemConfig.images[index]
        } else if (!(item.image && item.image.indexOf('.gif'))) { // TASK [HP] Improve
            item.image = null
        }
        if (itemConfig.icons && itemConfig.icons.hasOwnProperty(index)) {
            item.icons = itemConfig.icons[index]
        }
        // TODO - Overlay issues
        /*
        if (itemConfig.overlays && itemConfig.overlays.hasOwnProperty(index)) {
            item.overlays = itemConfig.overlays[index]
        }*/
        return item
    }

    function getThemeForItem(itemTheme, item, index, post) {
        itemTheme = JSON.parse(JSON.stringify(itemTheme))
        // Assign global theme configs
        if (post && post.data && post.data.theme && post.data.theme.global ) {
            itemTheme.global = Object.assign({}, post.data.theme.global)
        }
        if (!itemTheme.global) {
            itemTheme.global = {}
        }
        if (typeof itemTheme.global.applyRotation == 'undefined') {
            itemTheme.global.applyRotation = true
        }
        return parserService.getThemeForItem(itemTheme, item, index)
    }

    function getLayoutForItem(item, layout, expandedLayouts) {
        if (item.layout && !layout) {
            let foundLayout = expandedLayouts.find(layoutItem => layoutItem.label === item.layout)
            if (foundLayout) {
                layout = foundLayout
            } else {
                if (item?.layout?.startsWith(SMART_LAYOUTS_PREFIX)) {
                    try {
                        foundLayout = layoutService.getExpandedLayout(item.layout)
                        if (foundLayout) {
                            return foundLayout
                        }
                    } catch (e) {
                    }
                }
                // TODO - load or replace missing dynamic
                if (getLayoutParentId({label: item.layout})) {
                    api.findLayout({
                        label: item.layout,
                    }).then(function(response) {
                        if (response.data && response.data.data) {
                            addDynamicLayout(response.data)
                            $scope.refreshCalendar()
                            $timeout(angular.noop)
                        }
                    })
                    .catch(function(err) {
                        console.log('Error loading layout', err)
                    })
                }
            }
        }
        return layout
    }

    function isPostAlreadyEdited(post) {
        let published = post && post.publish && post.publish.items && post.publish.items.length > 0
        let wasEdited = post && post.meta && post.meta.edited

        return published || wasEdited
    }

    $scope.parsePost = function(item, layout, post, postIndex) {
        let itemConfig = {}
        if (post && post.data) {
            itemConfig = Object.assign({}, post.data)
        }
        let itemTheme = JSON.parse(JSON.stringify($scope.state.data.theme))

        try{
            // Apply visual settings
            let hasSettings = post && post.data && post.data.theme && post.data.theme.settings && post.data.theme.settings[0]
            if (hasSettings) {
                if (!itemTheme.settings) {
                    itemTheme.settings = {}
                }
                if (!itemTheme.settings[0]) {
                    itemTheme.settings[0] = {}
                }
                if (post.data.theme.settings[0].visual) {
                    itemTheme.settings[0].visual = Object.assign({}, post.data.theme.settings[0].visual)
                }
                if (post.data.theme.settings[0].invertColor) {
                    itemTheme.settings[0].invertColor = post.data.theme.settings[0].invertColor
                }
            }
        } catch (e) {
            logError({
                message: 'Error updating visual settings',
                error: e,
            })
        }
        // Keep the original theme for scheduled posts
        if (isPostAlreadyEdited(post)) {
            itemTheme = Object.assign({}, post.data.theme)

            if (itemConfig && itemConfig.global && itemConfig.global.content) {
                itemConfig.global = Object.assign({}, itemConfig.global)
            }
        } else if ($scope.state.data && $scope.state.data.global && $scope.state.data.global.content) {
            if (post?.data?.theme?.size) {
                itemTheme.size = post.data.theme.size
            }
            itemConfig.global = Object.assign({}, $scope.state.data.global)
        }
        let parsedPost = parserService.convertLayout(
            getLayoutForItem(item, layout, $scope.expandedLayouts),
            getContentForItem(item, itemConfig, 0),
            getThemeForItem(itemTheme, item, 0, post), {
                // TODO - fix
                mainId: 'calendar-' + postIndex,
            },
        );
        $scope.initAnimation(parsedPost, postIndex)
        return parsedPost
    }

    $scope.initAnimation = function(parsedPost, postIndex) {
        if ($scope.view.animators[postIndex]) {
            $scope.view.animators[postIndex].stop()
            $scope.view.animators[postIndex] = null
        }
        if (!$scope.posts || !$scope.posts[postIndex] || !$scope.posts[postIndex].meta || !$scope.posts[postIndex].meta.calendar || $scope.posts[postIndex].meta.calendar.what != 'reels') {
            return
        }

        let _instance = animator()
        $scope.view.animators[postIndex] = _instance
        try {
            _instance.init([parsedPost])
            _instance.start('loop', {
                startDelay: 500,
                statusCb: function(err) {
                    if (err) {
                        logError({
                            message: 'Error running animation',
                            error: err,
                        })
                    }
                }
            })
        } catch (e) {
            logError({
                message: 'Error initializing animation',
                error: e,
            })
        }
    }

    function addSmartLayout(newItem) {
        if (newItem.fullLayout && newItem.layout) {
            return layoutService.addDynamicLayout({
                data: newItem.fullLayout,
                id: newItem.layout,
            })
        }
        return Promise.resolve()
    }

    $scope.onNewPost = function(response) {
        response = JSON.parse(JSON.stringify(response))
        let item = response.content

        itemsGenerated++
        $rootScope.postsAmount = itemsGenerated

        let newPostId = null
        function addPost() {
            newPostId = $scope.parsedPosts.length
            $scope.items[newPostId] = item
            $scope.parsedPosts.push($scope.parsePost(item, null, null, newPostId))
            let postItem = {
                meta: {
                    calendar: {
                        status: 'pending',
                    }
                },
                data: {
                    items: [item]
                }
            }
            if ($scope.calendar.currentGenerateDay) {
                postItem.meta.calendar.date = $scope.calendar.currentGenerateDay
                $scope.calendar.currentGenerateDay = null
            }
            $scope.posts.push(postItem)
            $scope.planSchedulePost()

            return Promise.resolve()
        }

        return addSmartLayout(item)
        .then(addPost)
        .then(function() {
            $timeout(angular.noop)
            return Promise.resolve({
                id: newPostId,
                response: response
            })
        })
    }

    $scope.getPostById = function(id) {
        return $scope.parsedPosts[id]
    }

    $scope.postIsStory = function(id) {
        let post = $scope.posts[id]
        if (post.meta && post.meta.calendar && post.meta.calendar.what) {
            return post.meta.calendar.what == 'story'
        }
        return false
    }

    $scope.postHasFacebook = function(id) {
        let post = $scope.posts[id]
        if (post.meta && post.meta.calendar && post.meta.calendar.where) {
            return post.meta.calendar.where == 'facebook' || post.meta.calendar.where == 'both'
        }
        return false
    }

    $scope.postHasLinkedin = function(id) {
        let post = $scope.posts[id]
        if (post.meta && post.meta.calendar && post.meta.calendar.where) {
            return post.meta.calendar.where == 'linkedin'
        }
        return false
    }

    $scope.postHasInstagram = function(id) {
        let post = $scope.posts[id]
        if (post.meta && post.meta.calendar && post.meta.calendar.where) {
            return post.meta.calendar.where == 'instagram' || post.meta.calendar.where == 'both'
        }
        return false
    }

    $scope.getPostTime = function(id) {
        let post = $scope.posts[id]
        if (post.meta && post.meta.calendar && post.meta.calendar.time) {
            return post.meta.calendar.time
        }
        return '09:00'
    }

    $scope.getPostStatus = function(id) {
        let post = $scope.posts[id]
        if (post.publish && post.publish.items && post.publish.items[0] && post.publish.items[0].status) {
            return gettext('label.publish_status_' + post.publish.items[0].status)
        }
        return gettext('label.publish_status_pending')
    }

    $scope.getPostStatusClass = function(id) {
        let mapClass = {
            'pending': 'bg-warning',
            'initial': 'bg-info',
            'published': 'bg-success',
            'error': 'bg-danger',
        }
        let post = $scope.posts[id]
        let status = 'pending'
        if (post.publish && post.publish.items && post.publish.items[0] && post.publish.items[0].status) {
            status = post.publish.items[0].status
        }
        return mapClass[status]
    }

    $scope.onScheduleChange = function() {
        if ($scope.calendar.schedule.what && !validPostTypes.includes($scope.calendar.schedule.what)) {
            $scope.calendar.schedule.what = 'post+story+reels'
        }
        $scope.planSchedulePost('replan')
        $scope.view.calendarChanged = true
        $timeout(angular.noop)
    }

    $scope.onPostChanged = function(id) {
        $scope.parsedPosts[id] = $scope.convertPostToParsedPost($scope.posts[id], id)
        $timeout(angular.noop)
        $scope.savePostCalendar(id, false)
    }

    $scope.isLoading = function() {
        return $scope?.view?.loading?.savingReplan || $rootScope?.loading?.calendar || !$rootScope.started
    }

    $scope.isGeneratingLoggedOut = function(day) {
        let extraChecks = true
        if (day) {
            let availableDays = mapScheduleToDays[$scope.calendar.schedule.when]
            extraChecks = day.type == 'future' && (!day.posts || day.posts.length == 0) && availableDays.includes(day.value.getDay())
        }
        return $scope.isLoading() && !isLoggedIn() && extraChecks
    }

    $scope.editThemes = function() {
        if ($scope.isLoading()) {
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Edit Themes')) {
            return
        }
        let themesModal = angular.element('#themes-modal')
        themesModal.modal('show')
        themesModal.on('hidden.bs.modal', function() {
            $scope.view.choosingTopic = false
            $timeout(angular.noop)
        })
        track('Cal Edit Topics')
    }

    $scope.changeTopicFilter = function(type) {
        $scope.calendar.schedule.topicFilter = type
        $scope.saveCalendarConfig()
        track('Cal Change Topic Filter', {type})
    }

    $scope.processEditMessages = function(event) {
        if (!event || !event.data) {
            return
        }
        console.log('=> Received message from edit modal', event.data.name)
        if (event.data.name == 'postUpdated') {
            if (event.data.post) {
                let post = event.data.post
                if (!post || !event.data.id) {
                    return
                }
                let postIndex = $scope.posts.findIndex(p => p._id == event.data.id)
                if (postIndex < 0) {
                    return
                }
                $scope.posts[postIndex].data = post
                $scope.parsedPosts[postIndex] = $scope.convertPostToParsedPost($scope.posts[postIndex], postIndex)
                $scope.planSchedulePost()
                $timeout(angular.noop)
            }
        }
        else if (event.data.name == 'postScheduleUpdated') {
            if (event.data.schedule) {
                let schedule = event.data.schedule
                if (!schedule || !event.data.id) {
                    return
                }
                console.log('=> Received schedule update', schedule)
                let postIndex = $scope.posts.findIndex(p => p._id == event.data.id)
                if (postIndex < 0) {
                    return
                }
                if (!$scope.posts[postIndex].meta) {
                    $scope.posts[postIndex].meta = {}
                }
                if (!$scope.posts[postIndex].meta.calendar) {
                    $scope.posts[postIndex].meta.calendar = {}
                }
                if (schedule.where) {
                    $scope.posts[postIndex].meta.calendar.where = schedule.where
                }
                if (schedule.what) {
                    $scope.posts[postIndex].meta.calendar.what = schedule.what
                }
                if (schedule.date) {
                    $scope.posts[postIndex].meta.calendar.date = schedule.date
                }
                if (schedule.time) {
                    $scope.posts[postIndex].meta.calendar.time = schedule.time
                }

                // Used only to update status
                if (schedule.status == 'publish') {
                    $scope.posts[postIndex].publish = {
                        items: [
                            {
                                status: 'initial',
                            }
                        ]
                    }
                } else {
                    $scope.posts[postIndex].publish = {}
                }

                $scope.planSchedulePost()
                $timeout(angular.noop)
            }
        }
    }

    $scope.bulkEdit = function() {
        if (OPEN_EXTERNAL_EDIT) {
            window.open($scope.calendar.edit.url, '_blank', 'noopener')
            return
        }
        if (!$scope.posts || $scope.posts.length == 0) {
            showError(gettext('error.calendar_no_posts'))
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Bulk Edit')) {
            return
        }
        track('Cal Bulk Edit')
        let editModal = angular.element('#bulk-edit-modal')
        editModal.off('shown.bs.modal')
        editModal.off('hidden.bs.modal')

        editModal.on('shown.bs.modal', function() {
            $timeout(function() {
                let iframe = editModal.find('iframe')
                iframe.height(editModal.find('.modal-body').height() - 10)
                iframe.on('load', function() {
                    setTimeout(function() {
                        window.dispatchEvent(new Event('resize'))
                    }, 50)
                    try {
                        iframe[0].contentWindow.addEventListener('message', function(event) {
                            $scope.processEditMessages(event)
                        })
                    } catch (e) {
                        console.log('Error adding message listener', e, $scope.calendar.edit.url)
                    }
                })
                window.addEventListener('resize', function() {
                    if (iframe) {
                        iframe.height(editModal.find('.modal-body').height() - 10)
                    }
                })
            })
        })
        if (!$scope.view.currentPost) {
            $scope.view.currentEditPostIndex = 0
            if ($scope.updateCalendarEditURL('default')) {
                editModal.modal('show')
            }
        } else {
            editModal.modal('show')
        }
    }

    $scope.openEditModal = function(url) {
        $scope.view.currentPost = null
        if (url.startsWith('/') && $rootScope.baseEditor.endsWith('/')) {
            url = url.substring(1)
        }

        $scope.state.view.mainTab = 'calendar'

        let editModal = angular.element('#bulk-edit-modal')

        editModal.off('shown.bs.modal')
        editModal.off('hidden.bs.modal')

        editModal.on('shown.bs.modal', function() {
            $timeout(function() {
                let iframe = editModal.find('iframe')
                iframe.height(editModal.find('.modal-body').height() - 10)
                iframe.on('load', function() {
                    setTimeout(function() {
                        window.dispatchEvent(new Event('resize'))
                    }, 50)
                    iframe[0].contentWindow.addEventListener('message', function(event) {
                        $scope.processEditMessages(event)
                    })
                })
                window.addEventListener('resize', function() {
                    if (iframe) {
                        iframe.height(editModal.find('.modal-body').height() - 10)
                    }
                })
            })
        })

        editModal.on('hidden.bs.modal', function() {
            $timeout(function() {
                $scope.state.view.mainTab = 'create'
            })
        })

        editModal.modal('show')

        $scope.calendar.edit.url = $rootScope.baseEditor + url
    }

    $rootScope.$on('openEditModal', function(event, data) {
        $scope.openEditModal(data.url)
    })

    $scope.bulkEditConfirm = function() {
        let iframe = document.getElementById('bulk-edit-iframe')
        iframe.contentWindow.postMessage('schedulePost', '*')
    }

    function getPostConfigUrlParams(post) {
        if (isPostAlreadyEdited(post)) {
            return null
        }
        try {
            let updatedTheme = JSON.parse(JSON.stringify($scope.state.data.theme))
            delete updatedTheme.settings
            let global = JSON.parse(JSON.stringify($scope.state.data.global))
            if (global.config && global.config.hashtags) {
                delete global.config.hashtags
            }
            const base64String = toBinary(JSON.stringify({
                theme: updatedTheme,
                global: global,
            }))
            return '#config=' + base64String
        } catch (e) {
            console.log('Error encoding config', e)
        }
        return null
    }

    $scope.updateCalendarEditURL = function(typeSource) {
        let posts = []
        if (typeSource == 'sorted') {
            posts = $scope.getSortedPosts()
        } else {
            posts = $scope.posts
        }
        if (!posts) {
            return false
        }
        if ($scope.view.currentEditPostIndex < 0) {
            $scope.view.currentEditPostIndex = 0
        }
        if ($scope.view.currentEditPostIndex >= posts.length) {
            $scope.view.currentEditPostIndex = posts.length - 1
        }
        $scope.view.currentPost = posts[$scope.view.currentEditPostIndex]
        if (!$scope.view.currentPost) {
            return false
        }
        let postId = $scope.view.currentPost._id
        if (!postId) {
            showError(gettext("error.imageLoading"))
            return false
        }
        let params = [ 'embed=true' ]
        let post = $scope.view.currentPost
        if (post.meta && post.meta.calendar && post.meta.calendar.date) {
            params.push(`pdate=${post.meta.calendar.date}`)
        }
        if (post.meta && post.meta.calendar && post.meta.calendar.time) {
            params.push(`ptime=${post.meta.calendar.time}`)
        }
        if (post.meta && post.meta.calendar && post.meta.calendar.where) {
            params.push(`ptarget=${post.meta.calendar.where}`)
        }
        if (post.meta && post.meta.calendar && post.meta.calendar.what) {
            params.push(`ptype=${post.meta.calendar.what}`)
        }

        params = params.join('&')

        const baseURL = $rootScope.baseEditor
        let fullURL = `${baseURL}?id=${postId}&${params}`

        let postConfigURL = getPostConfigUrlParams(post)
        if (postConfigURL) {
            fullURL += postConfigURL
        }

        $scope.calendar.edit.url = fullURL
        return true
    }

    $scope.bulkEditPrevious = function() {
        $scope.view.currentEditPostIndex--
        $scope.updateCalendarEditURL('sorted')
        track('Cal Bulk Edit Previous')
    }

    $scope.bulkEditNext = function() {
        $scope.view.currentEditPostIndex++
        $scope.updateCalendarEditURL('sorted')
        track('Cal Bulk Edit Next')
    }

    $scope.saveCalendarConfig = function() {
        if (!$rootScope.isCustomer(showModal = true)) {
            return
        }
        let calendar = $scope.calendar.schedule
        api.updateProjectCalendar($scope.inputs.project, calendar).then(function(response) {
            // TODO - Success
            console.log('=> Updated calendar config', response)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error updating calendar config', err)
        })
    }

    $scope.loadCalendarConfig = function() {
        initGlobalConfig()
        if (!$scope.state.data.global.config.calendar) {
            $scope.calendar.schedule = Object.assign({}, defaultSchedule)
            $timeout(angular.noop)
            return
        }
        for (let key in $scope.state.data.global.config.calendar) {
            $scope.calendar.schedule[key] = $scope.state.data.global.config.calendar[key]
        }
        if ($scope.calendar.schedule.what && !validPostTypes.includes($scope.calendar.schedule.what)) {
            $scope.calendar.schedule.what = 'post+story+reels'
        }
        $scope.calendar.schedule.topicFilter = 'all'
    }

    $scope.getTopics = function(cb) {
        let project = 'empty'
        let focus = null
        if ($scope.inputs.project) {
            project = $scope.inputs.project
        }
        if ($scope.inputs.focus) {
            focus = $scope.inputs.focus
        }
        if ($scope?.state?.data?.global?.focus) {
            focus = $scope.state.data.global.focus
        }
        let params = {
            profile: $scope.inputs.profile,
            language: getContentLanguage(),
        }
        if (focus) {
            params.focus = focus
        }
        api.getTopics(project, params).then(function(response) {
            // TODO - Success
            $scope.calendar.topics = response.data.topics || []
            $scope.parseTopics()
            $timeout(angular.noop)
            if (cb) {
                cb()
            }
        }).catch(function(err) {
            if (cb) {
                cb(err)
            }
            // TODO - Error
            console.log('Error getting topics', err)
        })
    }

    $scope.deselectTopic = function(topic) {
        topic.selected = false
        $scope.parseTopics()
        $scope.saveTopics()
        track('Cal Topic Deselect', {topic: topic.label})
    }

    $scope.selectTopic = function(topic, event) {
        event.stopPropagation()
        if ($scope.calendar.schedule.topicFilter == 'all') {
            return
        }
        topic.selected = true
        $scope.parseTopics()
        $scope.saveTopics()
        track('Cal Topic Select', {topic: topic.label})
    }

    $scope.removeTopic = function(topic, event) {
        event.stopPropagation()
        // Remove from calendar.topics
        let index = $scope.calendar.topics.indexOf(topic)
        $scope.calendar.topics.splice(index, 1)
        $scope.parseTopics()
        $scope.saveTopics()
        track('Cal Topic Remove', {topic: topic.label})
    }

    $scope.deselectAllTopics = function() {
        for (topic of $scope.calendar.selectedTopics) {
            topic.selected = false
        }
        $scope.parseTopics()
        $scope.saveTopics()
        track('Cal Topic Deselect All')
    }

    $scope.selectAllTopics = function() {
        for (topic of $scope.calendar.availableTopics) {
            topic.selected = true
        }
        $scope.parseTopics()
        $scope.saveTopics()
        track('Cal Topic Select All')
    }

    $scope.getAvailableTopicsForGeneration = function(usePrevious) {
        let baseData = []
        if ($scope.unifiedView) {
            if ($scope.calendar.availableTopics && $scope.calendar.availableTopics.length > 0) {
                return $scope.calendar.availableTopics
            }
            if ($scope.calendar.topics && $scope.calendar.topics.length > 0) {
                return $scope.calendar.topics
            }
            return []
        }
        if ($scope.view.choosingTopic && usePrevious) {
            if ($scope.calendar.schedule.topicFilter == 'all') {
                baseData = $scope.view.previousAvailableTopics
            } else {
                baseData = $scope.view.previousSelectedTopics
            }
        } else {
            if ($scope.calendar.schedule.topicFilter == 'all') {
                baseData = $scope.calendar.availableTopics
            } else {
                baseData = $scope.calendar.selectedTopics
            }
        }
        return baseData || []
    }

    $scope.buildTopicsLabel = function() {
        let baseData = $scope.getAvailableTopicsForGeneration(true)
        let sample = baseData.slice(0, MAX_SAMPLE)

        let remaining = baseData.length - sample.length
        // label.calendar_other_themes or label.calendar_other_theme
        let otherLabel = remaining > 1 ? 'label.calendar_other_themes' : 'label.calendar_other_theme'
        let extraText = remaining > 0 ? `+${remaining} ${gettext(otherLabel)}` : ''

        $scope.calendar.info = {
            topics: sample,
            extra: extraText,
        }
    }

    $scope.getTopicsForGenerate = function() {
        let baseData = $scope.getAvailableTopicsForGeneration()
        if (baseData.length == 0) {
            return false
        }
        let shuffled = baseData.slice().sort(() => 0.5 - Math.random())
        let selected = shuffled.slice(0, MAX_SAMPLE_TOPICS_FOR_GENERATION)
        return selected.map(topic => `- ${topic.label}`).join('\n')
    }

    $scope.addTopic = function(newTopic) {
        // Max length topic is 150
        if (!newTopic || newTopic.trim() == '' || newTopic.length <= 3 || newTopic.length > 150) {
            showError(gettext('error.calendar_topic_length'))
            return
        }
        if ($scope.calendar.topics.find(topic => topic.label.toLowerCase() == newTopic.toLowerCase())) {
            showError(gettext('error.calendar_topic_exists'))
            return
        }
        let topic = {
            label: newTopic,
            selected: $scope.calendar.schedule.topicFilter == 'selected',
        }
        $scope.calendar.topics.push(topic)
        $scope.parseTopics()
        $scope.saveTopics()
        $scope.calendar.newTopic = ''
        track('Cal Topic Add', {topic: newTopic})
    }

    $scope.suggestTopics = function() {
        if (!$rootScope.isCustomer(showModal = true)) {
            return
        }
        $rootScope.loading.calendar = true
        let context = $scope.inputs.profile
        let inputTopics = {
            profile: context,
            language: getContentLanguage(),
            needs: $scope.inputs.needs_audience,
            goals: $scope.inputs.goals_audience,
            audience: $scope.inputs.audience,
        }
        if ($scope.calendar.newTopic) {
            inputTopics.topic = $scope.calendar.newTopic
        }
        api.suggestTopics($scope.inputs.project, inputTopics).then(function(response) {
            // TODO - Success
            let topics = response.data.topics || []
            topics = topics.map(topic => {
                return {
                    label: topic,
                    selected: false
                }
            })
            $rootScope.loading.calendar = false

            // Add to calendar.topics
            $scope.calendar.topics = $scope.calendar.topics.concat(topics)
            $scope.parseTopics()
            $scope.saveTopics(true)
            $timeout(angular.noop)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error getting topics', err)
        }).finally(function() {
            $rootScope.loading.calendar = false
            $timeout(angular.noop)
        })
        track('Cal Topic Suggest', {topic: $scope.calendar.newTopic})
    }

    $scope.saveTopics = function(force) {
        if ($scope.isLoading()) {
            return
        }
        if ($scope.view.choosingTopic && !force) {
            return
        }
        let topics = $scope.calendar.topics
        api.updateTopics($scope.inputs.project, {topics}).then(function(response) {
            // TODO - Success
            console.log('=> Updated topics', response)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error updating topics', err)
        })
    }

    $scope.$watch('calendar.schedule.topicFilter', function() {
        $scope.parseTopics()
    })

    $scope.parseTopics = function() {
        if (!$scope.calendar.topics) {
            return
        }
        // Make topics unique
        let uniqueTopics = new Set()
        let topicSelection = {}
        uniqueTopics = [...new Set($scope.calendar.topics.map(topic => topic.label))]
        for (topic of $scope.calendar.topics) {
            if (uniqueTopics.includes(topic.label)) {
                if (topicSelection[topic.label] === true) {
                    continue
                }
                topicSelection[topic.label] = topic.selected
            }
        }
        $scope.calendar.topics = uniqueTopics.map(topic => {
            return {
                label: topic,
                selected: topicSelection[topic] || false
            }
        })

        if ($scope.calendar.schedule.topicFilter == 'all') {
            $scope.calendar.availableTopics = $scope.calendar.topics
        } else {
            $scope.calendar.availableTopics = $scope.calendar.topics.filter(function(topic) {
                return !topic.selected
            })
            $scope.calendar.selectedTopics = $scope.calendar.topics.filter(function(topic) {
                return topic.selected
            })
        }
        $scope.buildTopicsLabel()
    }

    $scope.showPlanning = function() {
        $scope.view.showPlanning = true
        $scope.view.calendarChanged = false
        $scope.view.previousSchedule = Object.assign({}, $scope.calendar.schedule)

        let previousPostsSchedule = {}
        for (post of $scope.posts) {
            if (!post._id) {
                continue
            }
            if (post.meta && post.meta.calendar) {
                previousPostsSchedule[post._id] = Object.assign({}, post.meta.calendar)
            }
        }
        $scope.view.previousPostsSchedule = previousPostsSchedule

        $timeout(angular.noop)
        track('Cal Show Planning')
    }

    $scope.resetPlanning = function() {
        $scope.view.showPlanning = false
        $scope.view.calendarChanged = false
        if ($scope.view.previousSchedule) {
            $scope.calendar.schedule = Object.assign({}, $scope.view.previousSchedule)
        }
        if ($scope.view.previousPostsSchedule) {
            for (post of $scope.posts) {
                if (!post._id) {
                    continue
                }
                if (post.meta && post.meta.calendar) {
                    post.meta.calendar = Object.assign({}, $scope.view.previousPostsSchedule[post._id])
                }
            }
        }
    }
    $scope.hidePlanning = function() {
        $scope.resetPlanning()
        $scope.planSchedulePost()
        // Reset
        $timeout(angular.noop)
        track('Cal Hide Planning')
    }

    $scope.savePosts = function(postsToSave, showMessages) {
        let posts = []
        for (post of postsToSave) {
            if (!post.meta || !post.meta.calendar) {
                continue
            }
            if (post.publish && post.publish.items && post.publish.items.length > 0) {
                continue
            }
            if (!post._id) {
                continue
            }
            let postCalendar = post.meta.calendar
            if (postCalendar) {
                delete postCalendar.week
                delete postCalendar.day
                if (postCalendar?.date) {
                    postCalendar.scheduleAt = new Date(postCalendar.date).toISOString()
                    postCalendar.localeScheduleAt = postCalendar.date.toString()
                }
            }
            posts.push({
                id: post._id,
                calendar: postCalendar,
            })
        }
        if (posts.length > 0) {
            $rootScope.loading.calendar = true
            $scope.view.loading.savingReplan = true
            api.updateBulkCalendar({posts}).then(function(response) {
                // TODO - Success
                console.log('=> Updated posts', response)
                if (showMessages) {
                    showSuccess(gettext('label.calendar_replan_success'))
                }
            }).catch(function(err) {
                // TODO - Error
                console.log('Error updating posts', err)
                if (showMessages) {
                    showError(gettext('error.calendar_replan_error'))
                }
            }).finally(function() {
                $rootScope.loading.calendar = false
                $scope.view.loading.savingReplan = false
                $scope.view.showPlanning = false
                $scope.view.calendarChanged = false
                $timeout(angular.noop)
            })
        } else {
            $scope.view.showPlanning = false
            $scope.view.calendarChanged = false
        }
    }

    $scope.replanSave = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Save Replan')) {
            return
        }
        $scope.savePosts($scope.posts, true)
        $scope.saveCalendarConfig()
        track('Cal Save Replan')
    }

    $scope.savePostsReplannedOnLoad = function(posts) {
        $scope.savePosts(posts, false)
        posts.map(function(post) {
            console.log('=> Replanned on load', post._id, post.meta.calendar.date)
        })
        if (posts.length > 0) {
            track('Cal Replanned On Load', {count: posts.length})
        }
    }

    $scope.replan = function() {
        $scope.planSchedulePost('replan')
        track('Cal Replan')
    }

    $scope.getFlattenDays = function() {
        let flattenDays = []
        for (week of $scope.calendar.weeks) {
            for (day of week) {
                flattenDays.push(day)
            }
        }
        return flattenDays
    }

    function choosePostType(post) {
        let title = ''
        if (post && post.data && post.data.items && post.data.items[0] && post.data.items[0].title) {
            title = post.data.items[0].title
        }

        let currentType = $scope.calendar.schedule.what || 'post+story+reels'
        let types = currentType.split('+')
        // Posts have 2x more chance
        let choices = []
        if (types.includes('post')) {
            choices.push('post')
            choices.push('post')
        }
        if (types.includes('story')) {
            choices.push('story')
        }
        if (types.includes('reels')) {
            choices.push('reels')
        }

        // TODO - Rethink
        let selected = chooseWithHash(choices, title)
        return selected
    }

    function choosePostTarget() {
        return $scope.calendar.schedule.where || 'instagram'
    }

    function choosePostTime() {
        let possibleTimes = mapTimes[$scope.calendar.schedule.time || 'morning-afternoon']
        let selected = possibleTimes[Math.floor(Math.random() * possibleTimes.length)]
        return selected
    }

    $scope.choosePostCalendarConfig = function(planType, post) {
        let shouldReplan = planType == 'replan'
        let time = null
        let what = null
        let where = null

        // Choose post time
        if (post && post.meta && post.meta.calendar && typeof post.meta.calendar.time != 'undefined' && !shouldReplan) {
            time = post.meta.calendar.time
        } else if (post && post.meta && post.meta.calendar) {
            post.meta.calendar.time = choosePostTime()
            time = post.meta.calendar.time
        } else {
            time = choosePostTime()
        }

        // Choose post type
        if (post.meta && post.meta.calendar && typeof post.meta.calendar.what != 'undefined' && !shouldReplan) {
            what = post.meta.calendar.what
        } else if (post.meta && post.meta.calendar) {
            post.meta.calendar.what = choosePostType(post)
            what = post.meta.calendar.what
        } else {
            what = choosePostType()
        }
        // Choose post target
        if (post.meta && post.meta.calendar && typeof post.meta.calendar.where != 'undefined' && !shouldReplan) {
            where = post.meta.calendar.where
        } else if (post.meta && post.meta.calendar) {
            post.meta.calendar.where = choosePostTarget()
            where = post.meta.calendar.where
        } else {
            where = choosePostTarget()
        }
        return {
            time: time,
            what: what,
            where: where,
        }
    }

    $scope.planSchedulePost = function(planType) {

        let todayAtMidnight = new Date()
        todayAtMidnight.setHours(0, 0, 0, 0)

        let availableDays = mapScheduleToDays[$scope.calendar.schedule.when]

        for (week of $scope.calendar.weeks) {
            for (day of week) {
                day.posts = []
            }
        }

        $scope.calendar.scheduleFromPosts = {}

        let postsByDay = {}
        let postIndex = 0

        let updateReplanPosts = []
        let nonScheduledPosts = []
        // Build posts by day
        for (post of $scope.posts) {
            let hasDate = post.meta && post.meta.calendar && post.meta.calendar.date
            let isFavorite = post.meta && post.meta.calendar && post.meta.calendar.pinned
            let isAlreadyScheduled = post.publish && post.publish.items && post.publish.items.length > 0
            let forceReplan = post.meta && post.meta.calendar && post.meta.calendar.action == 'replan'

            let shouldKeep = hasDate
            if (planType == 'replan') {
                shouldKeep = (isFavorite || isAlreadyScheduled) && hasDate
            }
            if (forceReplan) {
                shouldKeep = false
                updateReplanPosts.push(post)
            }

            if (shouldKeep) {
                let date = new Date(post.meta.calendar.date)
                let day = date.getDate()
                let month = date.getMonth()
                let year = date.getFullYear()
                let key = `${year}-${month}-${day}`
                if (!postsByDay[key]) {
                    postsByDay[key] = []
                }
                postsByDay[key].push({
                    post: post,
                    index: postIndex,
                })
            } else {
                nonScheduledPosts.push({
                    post: post,
                    index: postIndex,
                })
            }
            postIndex++
        }

        // Add existing posts
        for (week of $scope.calendar.weeks) {
            for (day of week) {
                if (!day.posts) {
                    day.posts = []
                }

                try {
                    let monthNumber = day.value.getMonth() + 1
                    let dayNumber = day.value.getDate()
                    day.specialDates = []
                    day.specialDates = viewData?.specialDates?.main?.[monthNumber]?.[dayNumber] || []
                    day.specialDates = day.specialDates.concat(viewData?.specialDates?.default?.[monthNumber]?.[dayNumber] || [])
                } catch (e) {
                    console.log('Error getting special dates', e)
                }

                // Check if there are posts for this day
                let dayKey = `${day.value.getFullYear()}-${day.value.getMonth()}-${day.value.getDate()}`
                if (postsByDay[dayKey]) {
                    for (post of postsByDay[dayKey]) {
                        day.posts.push(post.index)
                        let postConfig = $scope.choosePostCalendarConfig('keep', post.post)
                        $scope.calendar.scheduleFromPosts[post.index] = Object.assign(postConfig, {
                            date: day.value,
                            week: week,
                            day: day,
                        })
                    }
                }
            }
        }

        // Sort non scheduled posts
        nonScheduledPosts = nonScheduledPosts.sort(function(a, b) {
            let dateA = a && a.post && a.post.meta && a.post.meta.calendar && a.post.meta.calendar.date ? a.post.meta.calendar.date : null
            let dateB = b && b.post && b.post.meta && b.post.meta.calendar && b.post.meta.calendar.date ? b.post.meta.calendar.date : null

            if (dateA && dateB) {
                dateA = new Date(dateA).getTime()
                dateB = new Date(dateB).getTime()
                return dateA < dateB ? -1 : 1
            }
            if (dateA) {
                return -1
            }
            if (dateB) {
                return 1
            }
            return a.index < b.index ? -1 : 1
        })

        let nonScheduledPostsIndex = 0
        for (week of $scope.calendar.weeks) {
            for (day of week) {
                if (!day.posts) {
                    day.posts = []
                }

                if (day.value < todayAtMidnight) {
                    day.type = 'past'
                } else {
                    day.type = 'future'
                }
                // Do no schedule if old date
                if (day.value < todayAtMidnight) {
                    continue
                }

                // Ignore if is skip day
                if ($scope.isSkipDay(day.value)) {
                    continue
                }

                // Schedule according to the selected days
                if (availableDays.includes(day.value.getDay())) {
                    if (day.posts.length > 0) {
                        continue
                    }

                    if (nonScheduledPostsIndex < nonScheduledPosts.length) {
                        let nonScheduledPost = nonScheduledPosts[nonScheduledPostsIndex]
                        let postConfig = $scope.choosePostCalendarConfig(planType, nonScheduledPost.post)
                        if (!nonScheduledPost.post.meta) {
                            nonScheduledPost.post.meta = {}
                        }
                        nonScheduledPost.post.meta.calendar = Object.assign(postConfig, {
                            status: 'pending',
                            date: day.value,
                        })
                        day.posts.push(nonScheduledPost.index)
                        $scope.calendar.scheduleFromPosts[nonScheduledPost.index] = Object.assign(postConfig, {
                            date: day.value,
                            week: week,
                            day: day,
                        })
                        nonScheduledPostsIndex++
                    }
                }
            }
        }

        // Schedule remaining posts
        if (nonScheduledPostsIndex < nonScheduledPosts.length) {
            // For the remaining posts, put them all in at the end + 1
            let lastDay = $scope.calendar.weeks[$scope.calendar.weeks.length - 1][$scope.calendar.weeks[$scope.calendar.weeks.length - 1].length - 1].value

            // Add 24 hours offset
            lastDay = new Date(lastDay.getTime() + 24 * 60 * 60 * 1000)

            for (let i = nonScheduledPostsIndex; i < nonScheduledPosts.length; i++) {
                let nonScheduledPost = nonScheduledPosts[i]
                let postConfig = $scope.choosePostCalendarConfig(planType, nonScheduledPost.post)
                nonScheduledPost.post.meta.calendar = Object.assign(postConfig, {
                    status: 'pending',
                    action: 'replan',
                    date: new Date(lastDay),
                })
                $scope.calendar.scheduleFromPosts[nonScheduledPost.index] = Object.assign(postConfig, {
                    date: new Date(lastDay),
                    action: 'replan',
                    week: $scope.calendar.weeks[$scope.calendar.weeks.length - 1],
                    day: $scope.calendar.weeks[$scope.calendar.weeks.length - 1][$scope.calendar.weeks[$scope.calendar.weeks.length - 1].length - 1],
                })
            }

        }
        $timeout(angular.noop)

        if (updateReplanPosts.length > 0) {
            $scope.savePostsReplannedOnLoad(updateReplanPosts)
        }
    }

    function getWeekOfMonth(date) {
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        // Adjust so that Monday = 0, Sunday = 6
        const firstDayOfWeek = (firstDay.getDay() + 6) % 7;

        const offsetDate = date.getDate() + firstDayOfWeek;
        return Math.ceil(offsetDate / 7);
    }

    $scope.buildMonthDaysCalendar = function(month, year) {
        let todayAtMidnight = new Date()
        todayAtMidnight.setHours(0, 0, 0, 0)
        // Create a date object for the first day of the given month and year
        var firstDayOfMonth = new Date(year, month - 1, 1);
        // Determine the day of the week for the first day, adjusting for Monday start (0=Monday, 6=Sunday)
        var firstDayWeekDay = (firstDayOfMonth.getDay() + 6) % 7;
        // Calculate the previous month's overflow days to display at the start of the calendar
        var previousMonthOverflow = firstDayWeekDay;
        // Calculate the start date for the calendar view by subtracting the overflow days
        var startDate = new Date(firstDayOfMonth);
        startDate.setDate(startDate.getDate() - previousMonthOverflow);

        // Create a date object for the last day of the given month and year
        var lastDayOfMonth = new Date(year, month, 0); // 0 gets the last day of the previous month
        // Determine the day of the week for the last day, adjusting for Monday start
        var lastDayWeekDay = (lastDayOfMonth.getDay() + 6) % 7;
        // Calculate the next month's overflow days to display at the end of the calendar
        var nextMonthOverflow = 6 - lastDayWeekDay;
        // Calculate the end date for the calendar view by adding the overflow days
        var endDate = new Date(lastDayOfMonth);
        endDate.setDate(endDate.getDate() + nextMonthOverflow);

        // Shows up additional days when the month is current
        if (endDate.getMonth() == new Date().getMonth() && endDate.getFullYear() == new Date().getFullYear()) {
            endDate = new Date(todayAtMidnight)
        }

        // Calculate offset
        let weekOfMOnth = getWeekOfMonth(new Date())
        // If current month, then we need to calculate the offset
        if (month == new Date().getMonth() + 1) {
            let offset = (weekOfMOnth - 1) * 7 * 24 * 60 * 60*1000
            startDate = new Date(startDate.getTime() + offset)
            endDate = new Date(endDate.getTime() + offset)
        } else if (month == new Date().getMonth() && weekOfMOnth > 1) {
            let offset = (weekOfMOnth - 2) * 7 * 24 * 60 * 60*1000
            endDate = new Date(endDate.getTime() + offset)
        }

        // Initialize an array to hold the weeks
        var weeks = [];
        var currentDate = new Date(startDate);
        // Loop through the dates from start to end date to fill the calendar weeks
        while (currentDate <= endDate) {
            var week = [];
            // Fill the week array with days
            for (var i = 0; i < 7; i++) {
                let typeDay = currentDate < todayAtMidnight ? 'past' : 'future'
                week.push({
                    imageType: DEFAULT_IMAGE_TYPE,
                    value: new Date(currentDate),
                    type: typeDay,
                })
                currentDate.setDate(currentDate.getDate() + 1);
            }
            // Add the completed week to the weeks array
            weeks.push(week);
        }

        // Return the array of weeks, each containing the days to display in the calendar
        return weeks;
    };

    $scope.saveItem = function(item, postId) {
        if (!$scope.state.data.theme) {
            return
        }
        let uniqueId = null
        try {
            uniqueId = localStorage.getItem('galilai.uuid')
        } catch (e) {
            logError({
                message: 'Error getting uniqueId',
                error: e,
            })
        }
        // Remove settings
        let themeToSave = JSON.parse(JSON.stringify($scope.state.data.theme))
        if (themeToSave.settings) {
            delete themeToSave.settings
        }

        let meta = {
            project: $scope.inputs.project,
            instagram: $scope.inputs.handle,
            uuid: uniqueId,
        }

        if ($scope.calendar.scheduleFromPosts[postId]) {
            meta.calendar = {}
            for (key in $scope.calendar.scheduleFromPosts[postId]) {
                if (key == 'day' || key == 'week') {
                    continue
                }
                meta.calendar[key] = $scope.calendar.scheduleFromPosts[postId][key]
            }
        }

        let postToCreate = {
            item: item.content,
            theme: themeToSave,
            meta: meta,
        }
        if (postToCreate.item && postToCreate.item.fullLayout) {
            if (postToCreate.item.layout.startsWith(SMART_LAYOUTS_PREFIX)) {
                postToCreate.layout = postToCreate.item.fullLayout
            } else {
                postToCreate.layout = postToCreate.item.fullLayout.data
            }
            delete postToCreate.item.fullLayout
        }
        api.getOrCreatePost(postToCreate).then(function(response) {
            let data = response.data
            $scope.$broadcast('calendarItemChanged', {
                id: item.content.id,
                changes: {
                    serverId: data._id
                }
            })

            if (!$scope.posts[postId]) {
                console.warn('No post found for id', postId)
                $scope.posts[postId] = {}
            }
            $scope.posts[postId]._id = data._id
        })
        .catch(function(e) {
            // TASK - No handling
            logError({
                message: 'Error saving item',
                error: e,
            })
        })
    }

    $scope.isPinned = function(postId) {
        if (!$scope.posts[postId]) {
            return false
        }
        return $scope.posts[postId].meta && $scope.posts[postId].meta.calendar && $scope.posts[postId].meta.calendar.pinned
    }

    $scope.isScheduled = function(postId) {
        if (!$scope.posts[postId]) {
            return false
        }
        return $scope.posts[postId].publish && $scope.posts[postId].publish.items && $scope.posts[postId].publish.items.length > 0
    }

    $scope.removeSchedule = function(postId) {
        if (!$scope.posts[postId]) {
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Remove Schedule')) {
            return
        }
        let serverId = $scope.posts[postId]._id
        if (!serverId) {
            return
        }
        api.cancelPublish(serverId).then(function(response) {
            // TODO - Success
            console.log('=> Removed scheduled', response)
            $scope.posts[postId].publish = {}
            $timeout(angular.noop)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error removing scheduled', err)
        })
        track('Cal Remove Schedule', {postId: postId})
    }

    $scope.favoritePost = function(postId) {
        let serverId = $scope.posts[postId]._id
        if (!serverId) {
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Pin Post')) {
            return
        }
        $scope.posts[postId].meta.calendar.pinned = !$scope.posts[postId].meta.calendar.pinned
        api.updatePostPinned(serverId, $scope.posts[postId].meta.calendar.pinned).then(function(response) {
            // TODO - Success
            console.log('=> Updated pinned', response)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error updating pinned', err)
        })
        track('Cal Pin Post', {postId: postId})
    }

    $scope.finishThemeSelection = function() {
        let context = $scope.getTopicsForGenerate()
        if (!context) {
            showError(gettext('error.calendar_no_topics'))
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Finish Theme Selection')) {
            return
        }
        let themesModal = angular.element('#themes-modal')
        themesModal.modal('hide')

        $timeout(function() {
            $scope.view.choosingTopic = false
            $scope.generatePost($scope.view.currentGenerateDay)
            $scope.calendar.topics = JSON.parse(JSON.stringify($scope.view.previousTopics))
            $scope.parseTopics()
        })
        track('Cal Finish Topic Selection')
    }

    $scope.generatePost = function(day, typeAction) {
        let date = null
        if (typeof day.value != 'undefined') {
            date = day.value
        } else {
            date = day
        }
        if ($scope.preventGenerateLoggedOut()) {
            return
        }

        if (typeAction == 'existing') {
            $scope.calendar.currentGenerateDay = date
            $scope.view.currentGenerateDay = date

            $scope.showCalendarGenerationModal('single', 'existing', {
                selectedDate: date,
            })
            return
        }

        if (typeAction == 'choose') {
            $scope.calendar.currentGenerateDay = date
            $scope.view.currentGenerateDay = date

            if ($scope.unifiedView) {
                $scope.showCalendarGenerationModal('single', 'themes', {
                    selectedDate: date,
                })
            } else {
                $scope.view.choosingTopic = true
                $scope.view.previousTopics = JSON.parse(JSON.stringify($scope.calendar.topics))
                $scope.view.previousAvailableTopics = JSON.parse(JSON.stringify($scope.calendar.availableTopics))
                $scope.view.previousSelectedTopics = JSON.parse(JSON.stringify($scope.calendar.selectedTopics))
                $scope.editThemes()
            }
            return
        }

        let context = $scope.getTopicsForGenerate()
        if (!context) {
            $scope.editThemes()
            showError(gettext('error.calendar_no_topics'))
            return
        }
        if (typeAction) {
            $scope.view.loadingGenerate[date] = true
        }
        $scope.calendar.currentGenerateDay = date
        let imageType = day.imageType || DEFAULT_IMAGE_TYPE
        $scope.generateCalendar('single', typeAction, imageType)
        track('Cal Generate Single Post', {type: typeAction})
    }

    $scope.regeneratePost = function(postId, date) {
        let serverId = $scope.posts[postId]._id
        if (!serverId) {
            showError(gettext('error.imageLoading'))
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Regenerate Post')) {
            return
        }
        $scope.removePost(postId)
        $scope.generatePost(date, 'single')
        track('Cal Regenerate Post', {postId: postId})
    }

    $scope.stopGenerating = function() {
        $timeout(function() {
            $rootScope.loading.calendar = false
            $scope.state.view.generating = false
            if (currentReader) {
                currentReader.cancel()
                $timeout(() => {
                    currentReader = null
                })
            }
            $scope.view.loadingGenerate = {}
            $timeout(angular.noop)
        })
    }

    $scope.canGenerateMore = function() {
        let availableDays = mapScheduleToDays[$scope.calendar.schedule.when]
        let emptySlots = 0
        for (week of $scope.calendar.weeks) {
            for (day of week) {
                if (!availableDays.includes(day.value.getDay())) {
                    continue
                }
                if ($scope.isSkipDay(day.value)) {
                    continue
                }
                if (day.type == 'past') {
                    continue
                }
                if (!day.posts || (day.posts && day.posts.length == 0)) {
                    emptySlots++
                }
            }
        }
        return {
            available: emptySlots > 0,
            slots: emptySlots,
        }
    }

    $scope.processErrors = function(err) {
        if (err && err.message == 'error.generate_empty_profile') {
            $rootScope.loading.calendar = false
            $rootScope.$broadcast('showPersona')
        }
    }

    $scope.preventGenerateLoggedOut = function() {
        if (localStorage.getItem('galilai.generation.complete') != null && !isLoggedIn()) {
            $rootScope.showTrial('Generated once but not logged in')
            return true
        }
        return false
    }

    function addDynamicLayout(layout) {
        try {
            let dynamicLayoutKey = layout.id.split('.').slice(0, -1).join('.')
            if (!$scope.expandedLayouts.find(layout => layout.label == dynamicLayoutKey)) {
                for (layout of layoutService.expand(layout.data, dynamicLayoutKey, $scope.layoutsConfig.layouts)) {
                    $scope.expandedLayouts.push(layout)
                }
            }
        } catch (err) {
            logError({
                message: 'Error adding dynamic layout',
                error: err,
            })
        }
    }

    function onNewPosts(posts) {
        for (let post of posts) {
            if ($scope.calendar.currentGenerateDay) {
                if (!post.meta) {
                    post.meta = {}
                }
                if (!post.meta.calendar) {
                    post.meta.calendar = {}
                }
                post.meta.calendar.date = $scope.calendar.currentGenerateDay
            }
            $scope.posts.push(post)
            $scope.parsedPosts.push($scope.convertPostToParsedPost(post))
        }
        $scope.planSchedulePost()

        $scope.savePosts(posts, false)
        $scope.calendar.currentGenerateDay = null
        $timeout(angular.noop)

    }

    $scope.showSpecialDatesModal = function(day, specialDate) {
        let date = null
        if (typeof day.value != 'undefined') {
            date = day.value
        } else {
            date = day
        }
        $scope.calendar.currentGenerateDay = date
        $scope.view.currentGenerateDay = date
        let formatted = date.getDate() + '/' +  gettext('label.month_long_' + (date.getMonth() + 1))
        $scope.showCalendarGenerationModal('single', 'dates', {
            context: specialDate.name + ' ' + formatted
        })
    }

    $scope.generateCalendar = function(generationType, postFormat, imageType) {
        let canGenerate = $scope.canGenerateMore()
        if (!canGenerate.available && generationType != 'single') {
            showError(gettext('error.calendar_full'))
            return
        }
        if ($scope.preventGenerateLoggedOut()) {
            return
        }

        if (!postFormat && generationType != 'auto') {
            let params = {}
            if (generationType == 'single') {
                params.selectedDate = $scope.calendar.currentGenerateDay
            }
            $scope.showCalendarGenerationModal(generationType, null, params)
            return
        }
        if (generationType == 'auto') {
            generationType = null
        }

        let context = $scope.getTopicsForGenerate()
        if (!context) {
            $scope.editThemes()
            showError(gettext('error.calendar_no_topics'))
            return
        }

        let inputs = [$scope.inputs.profile, context].filter(function(input) {
            return input && input.trim() !== ''
        }).join('\n').trim()

        let amountToGenerate = Math.min(canGenerate.slots, 10) || 10
        let MIN_AMOUNT = generationType == 'single' ? 1 : 1
        let isGenerating = true

        $rootScope.loading.calendar = true

        try {
            track('Editor Generate Ideas')
        } catch (err) {
            console.log(err)
        }

        function generationCallback(err, response, done, reader) {
            if (!isGenerating) {
                return
            }
            currentReader = reader;
            if (err) {
                $scope.processErrors(err)
                if (err && err.message && gettext(err.message) != '' && typeof gettext(err.message) == 'string') {
                    showError(gettext(err.message))
                } else if ($rootScope.postsAmount < MIN_AMOUNT) {
                    showError(gettext('error.generating.content'))
                }
                $scope.stopGenerating()
                return
            }
            if (done) {
                $rootScope.loading.calendar = false
                track('Editor Generate Finished', {
                    amount: itemsGenerated
                })
                return
            }
            if (itemsGenerated == 0) {
                track('Editor Generate Success')
            }
            if (generationType == 'single') {
                $scope.stopGenerating()
                isGenerating = false
                // Stop loading state
                for (let key in $scope.view.loadingGenerate) {
                    $scope.view.loadingGenerate[key] = false
                }
            }
            localStorage.setItem('galilai.generation.complete', true)
            $rootScope.alreadyGenerated = true
            // Add new post
            let dynamicLayout = null
            if (getLayoutParentId({label: response.content.layout}) && !$scope.expandedLayouts.find(layout => layout.label == response.content.layout)) {
                dynamicLayout = response.content.layout
                response.content.layout = 'empty.loading'
                response.content.meta.layout = response.content.layout
            }

            $scope.onNewPost(response)
            .then(function(result) {
                let newPostId = result.id
                let itemResponse = result.response
                itemResponse.content.id = newPostId

                let item = JSON.parse(JSON.stringify(itemResponse.content))
                if (item.settings.dynamic || dynamicLayout) {
                    let paramsDynamic = JSON.parse(JSON.stringify(item))
                    if (dynamicLayout) {
                        paramsDynamic.layout = dynamicLayout
                    }
                    paramsDynamic.project = $scope.inputs.project
                    // Add token
                    function generateDynamic(itemResponse, newItemId) {

                        api.generateDynamic(paramsDynamic).then(function(response) {
                            let data = response.data
                            let changes = {}
                            if (data.image && data.image.url) {
                                changes.image = data.image.url
                                itemResponse.content.image = data.image.url
                            } else if (item.settings.dynamic && item.settings.dynamic.image) {
                                changes.image = null
                                itemResponse.content.image = null
                            }
                            if (data.title) {
                                changes.title = data.title
                                itemResponse.content.title = data.title
                            }
                            if (typeof data.description != 'undefined') {
                                changes.description = data.description
                                itemResponse.content.description = data.description
                            }

                            if (data.layout) {
                                addDynamicLayout(data.layout)
                                changes.fullLayout = data.layout
                            }
                            console.log('=> Dynamic changes', changes)
                            $scope.$broadcast('calendarItemChanged', {
                                id: newItemId,
                                changes: changes
                            })
                            $timeout(() => {
                                $scope.saveItem(itemResponse, newPostId)
                            })
                        }).catch(function(err) {
                            if (item.settings.dynamic && item.settings.dynamic.image) {
                                $scope.$broadcast('calendarItemChanged', {
                                    id: newItemId,
                                    changes: {
                                        image: null
                                    }
                                })
                                itemResponse.content.image = null
                            }
                            $timeout(() => {
                                $scope.saveItem(itemResponse, newPostId)
                            })
                        })
                    }
                    generateDynamic(itemResponse, newPostId)
                } else {
                    $scope.saveItem(itemResponse, newPostId)
                }

                // Generate only necessary amount
                if (itemsGenerated >= amountToGenerate) {
                    console.log('=> Generated enough', itemsGenerated, amountToGenerate)
                    $scope.stopGenerating()
                }
            })
        }
        $rootScope.$emit('clearRetries')
        itemsGenerated = 0
        $rootScope.postsAmount = 0

        $scope.getLanguageWithFallback(inputs, function(generationLanguage) {
            if (generationLanguage) {
                $scope.setContentLanguage(generationLanguage)
            }

            // Start generation
            let generateInputs = {
                inputs: {
                    userMedias: $scope.state.data.selectedMedias,
                    language: generationLanguage,
                    profile: $scope.inputs.profile,
                    context: context,
                    needs: $scope.inputs.needs_audience,
                    goals: $scope.inputs.goals_audience,
                    audience: $scope.inputs.audience,
                    format: postFormat,
                    imageType: imageType,
                },
                social: $scope.inputs.social,
            }
            if (generationType == 'single') {
                generateInputs.inputs.single = true
            } else {
                generateInputs.inputs.multiple = true
                generateInputs.inputs.amount = amountToGenerate
            }
            $scope.generateIdeasStream(generateInputs, generationCallback)
        })

        track('Cal Generate', {
            type: generationType
        })
    }

    $scope.toggleBulkEditDropdown = function(event) {
        $timeout(function() {
            $scope.state.view.bulkEditorDropdown = !$scope.state.view.bulkEditorDropdown
        })
        event.stopPropagation()
    }

    $scope.onProjectChanged = function() {
        $scope.calendar.topics = []
        $scope.parseTopics()
        $scope.fetchCalendar()
    }

    $scope.convertPostToParsedPost = function(post, index) {
        let firstItem = post.data.items[0]
        let layout = null
        if (post.data.layouts && post.data.layouts.length > 0 && post.data.layouts[0]) {
            layout = post.data.layouts[0]
        }
        let result = $scope.parsePost(firstItem, layout, post, index)
        try {
            if (post?.data?.theme?.size?.height > 1.25) {
                if (!result.classes) {
                    result.classes = {}
                }
                result.classes['size-stories'] = true
            }
        } catch (e) {
            console.log('Error getting size', e)
        }
        return result
    }

    $scope.onSpecialDatesChanged = function() {
        api.updateProjectGlobalSingle($scope.inputs.project, {
            'config.datesCategory': $scope?.state?.data?.global?.config?.datesCategory || 'default'
        }).then(function(response) {
            // TASK - No handling
        })
        .catch(function() {
            // TASK - No handling
        })

        $scope.fetchCalendar()
    }

    $scope.fetchCalendar = function() {
        if ($scope.state.view.mainTab == 'calendar') {
            $rootScope.$broadcast('clearPosts')
        }
        let params = {
            type: 'calendar-range',
            project: $scope.inputs.project,
            datesCategory: $scope.state.data.global.config.datesCategory,
            filter: 'all',
            from: $scope.calendar.weeks[0][0].value.toISOString(),
            to: $scope.calendar.weeks[$scope.calendar.weeks.length - 1][$scope.calendar.weeks[$scope.calendar.weeks.length - 1].length - 1].value.toISOString(),
        }
        $rootScope.loading.calendar = true
        api.getPosts(params).then(function(response) {
            function filterPosts(posts) {
                // Remove posts without items
                return posts.filter(function(post) {
                    return post.data && post.data.items && post.data.items.length > 0
                })
            }
            function fixPosts(posts) {
                return posts.map(function(post) {
                    if (post.meta && post.meta.calendar && (post.meta.calendar.what || typeof post.meta.calendar.what == 'undefined')) {
                        if (!validPostTypes.includes(post.meta.calendar.what)) {
                            post.meta.calendar.what = 'post'
                        }
                    }
                    return post
                })
            }
            let posts = response.data.posts
            posts = fixPosts(posts)
            posts = filterPosts(posts)

            try {
                const hasBusinessError = posts.filter(function(post) {
                    return post?.publish?.items?.[0]?.status == 'error' && post?.publish?.items?.[0]?.error == 'instagram_business_error'
                })
                $scope.view.errors.instagramBusiness = hasBusinessError.length > 0
                const hasRateLimiting = posts.filter(function(post) {
                    return post?.publish?.items?.[0]?.status == 'error' && post?.publish?.items?.[0]?.error == 'rate_limit'
                })
                $scope.view.errors.rateLimit = hasRateLimiting.length > 0

                const hasUserRestricted = posts.filter(function(post) {
                    return post?.publish?.items?.[0]?.status == 'error' && post?.publish?.items?.[0]?.error == 'user_restricted'
                })
                $scope.view.errors.userRestricted = hasUserRestricted.length > 0

                const hasReauthRequired = posts.filter(function(post) {
                    return post?.publish?.items?.[0]?.status == 'error' && post?.publish?.items?.[0]?.error == 'reauth_required'
                })
                $scope.view.errors.reauthRequired = hasReauthRequired.length > 0
            } catch (e) {
                console.log('Error checking instagram business error', e)
            }
            $scope.posts = posts
            viewData.specialDates = response.data.specialDates
            $scope.parsedPosts = $scope.posts.map(function(post, index) {
                return $scope.convertPostToParsedPost(post, index)
            })
            $scope.planSchedulePost('initial')
            $timeout(angular.noop)
        })
        .catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $rootScope.loading.calendar = false
            $timeout(angular.noop)
        })
    }

    $scope.getCurrentMonthName = function() {
        return gettext('label.month_long_' + $scope.view.currentMonth)
    }

    $scope.getCalendarFormattedDate = function(date) {
        // check if is today
        let today = new Date()
        if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear()) {
            return gettext('label.today')
        }
        let day = date.getDate()
        let month = date.getMonth() + 1
        let formattedMonth = gettext('label.month_short_' + month)
        return `${day}/${formattedMonth}`
    }

    $scope.previousRange = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Change Calendar Range')) {
            return
        }
        $scope.view.currentMonth--
        if ($scope.view.currentMonth < 1) {
            $scope.view.currentMonth = 12
            $scope.view.currentYear--
        }
        $scope.resetPlanning()
        $scope.buildCalendar()
        $scope.fetchCalendar()
        track('Cal Previous Range', {
            month: $scope.view.currentMonth,
            year: $scope.view.currentYear
        })
    }

    $scope.rangeToday = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Change Calendar Range')) {
            return
        }
        let today = new Date()
        $scope.view.currentMonth = today.getMonth() + 1
        $scope.view.currentYear = today.getFullYear()
        $scope.resetPlanning()
        $scope.buildCalendar()
        $scope.fetchCalendar()
        track('Cal Range Today')
    }

    $scope.nextRange = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Change Calendar Range')) {
            return
        }
        $scope.view.currentMonth++
        if ($scope.view.currentMonth > 12) {
            $scope.view.currentMonth = 1
            $scope.view.currentYear++
        }
        $scope.resetPlanning()
        $scope.buildCalendar()
        $scope.fetchCalendar()
        track('Cal Next Range', {
            month: $scope.view.currentMonth,
            year: $scope.view.currentYear
        })
    }

    $scope.buildCalendar = function() {
        $scope.calendar.weeks = $scope.buildMonthDaysCalendar($scope.view.currentMonth, $scope.view.currentYear)
    }

    $scope.getSortedPosts = function() {
        return $scope.posts.slice().sort(function(a, b) {
            if (!a.meta || !a.meta.calendar || !a.meta.calendar.date) {
                return -1
            }
            if (!b.meta || !b.meta.calendar || !b.meta.calendar.date) {
                return 1
            }

            let dateA = a.meta.calendar.date
            let dateB = null
            if (typeof a.meta.calendar.date === 'string') {
                dateA = new Date(a.meta.calendar.date)
            }
            if (typeof b.meta.calendar.date === 'string') {
                dateB = new Date(b.meta.calendar.date)
            }
            if (dateA < dateB) {
                return -1
            }
            if (dateA > dateB) {
                return 1
            }
            return 0
        })
    }

    $scope.getImprovedPostTitle = function(post) {
        if (!post) {
            return ''
        }
        if (!post.meta || !post.meta.calendar || !post.meta.calendar.date) {
            return ''
        }
        let date = post.meta.calendar.date
        let formattedDate = ''
        if (typeof date === 'string') {
            date = new Date(date)
        }
        if (typeof date === 'undefined') {
            // TODO - Investigate
            // console.log('Error getting improved post title', post._id, post.meta.calendar)
            return ''
        }
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        let formattedMonth = gettext('label.month_short_' + month)
        formattedDate = `${day}/${formattedMonth}`

        if (!post.data.items[0]) {
            return ''
        }
        let improvedTitle = post.data.items[0].title || post.data.items[0].description || ''
        // Remove all html tags from the title
        improvedTitle = improvedTitle.replace(/(<([^>]+)>)/ig, '')
        const maxTitleLength = 50
        if (improvedTitle.length > maxTitleLength) {
            improvedTitle = improvedTitle.substring(0, maxTitleLength) + '...'
        }
        return `${formattedDate} - ${improvedTitle}`
    }

    $scope.selectEditPost = function(post, index) {
        $scope.view.currentEditPostIndex = index
        $scope.state.view.bulkEditorDropdown = false
        $scope.updateCalendarEditURL('sorted')
        $timeout(angular.noop)

        track('Cal Select Edit Post', {
            postId: post._id
        })
    }

    /* Actions */
    $scope.duplicatePost = function(postId) {
        let post = $scope.posts[postId]
        let serverId = post._id
        if (!serverId) {
            showError(gettext('error.imageLoading'))
            return
        }
        api.duplicatePost(serverId).then(function(response) {
            $scope.fetchCalendar()
        }).catch(function(err) {
            showError(gettext('error.generic'))
        })
    }

    $scope.removePost = function(postId, type) {
        let removeDay = $scope.calendar.scheduleFromPosts[postId].date
        let serverId = $scope.posts[postId]._id
        if (!serverId) {
            // TODO - Wait for server id
            showError(gettext('error.imageLoading'))
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Remove Post')) {
            return
        }
        if ($scope.items[postId]) {
            $scope.items.splice(postId, 1)
        }
        $scope.posts.splice(postId, 1)
        $scope.parsedPosts.splice(postId, 1)
        $scope.planSchedulePost()

        api.removeCalendar(serverId).then(function(response) {
            // TODO - Success
            console.log('=> Removed post', serverId)
        }).catch(function(err) {
            // TODO - Error
            console.log('Error removing post', err)
        })
        if (type == 'skip') {
            $scope.skipDay(removeDay)
        } else if (type == 'generate') {
            $scope.generatePost(removeDay, 'single')
        }
        track('Cal Remove Post', {postId: postId})
    }

    $scope.editPost = function(postId) {
        if (!$rootScope.isCustomer(showModal = true, source='Edit Post')) {
            return
        }
        $scope.view.currentEditPostIndex = postId
        if (typeof $scope.view.currentEditPostIndex === 'undefined' || $scope.view.currentEditPostIndex === null) {
            $scope.view.currentEditPostIndex = 0
            return
        }
        if ($scope.updateCalendarEditURL('default')) {
            $scope.bulkEdit()
        }
        track('Cal Edit Single Post', {postId: postId})
    }

    $scope.toggleRemoveDropdown = function(postId, event) {
        for (let key in $scope.view.removeDropdown) {
            if (key == postId) {
                continue
            }
            $scope.view.removeDropdown[key] = false
        }
        $scope.view.removeDropdown[postId] = !$scope.view.removeDropdown[postId]
        event.stopPropagation()
        $timeout(function(){
            dropdownRightFix(event)
        })
    }

    function dropdownRightFix(event) {
        try {
            let positionX = event.target.getBoundingClientRect().x

            let buttonSize = 0
            let parent = event.target.parentElement
            if (parent.tagName == 'BUTTON') {
                buttonSize = parent.offsetWidth
                parent = parent.parentElement
            } else {
                buttonSize = event.target.offsetWidth
            }
            let dropdown = parent.querySelector('.dropdown-menu')
            let offsetSize = dropdown.offsetWidth - buttonSize

            if (positionX > window.innerWidth - 200) {
                dropdown.style.transform = `translate(-${offsetSize}px, 0px)`
            } else {
                dropdown.style.transform = 'translate(0px, 0px)'
            }
        } catch (e) {
            console.log('Error toggling settings dropdown', e)
        }
    }
    $scope.toggleSettingsDropdown = function(day, event) {
        day = day.toISOString().split('T')[0]
        for (let key in $scope.view.settingsDropdown) {
            if (key == day) {
                continue
            }
            $scope.view.settingsDropdown[key] = false
        }
        $scope.view.settingsDropdown[day] = !$scope.view.settingsDropdown[day]
        event.stopPropagation()
        $timeout(function(){
            dropdownRightFix(event)
        })
    }

    $scope.isSettingsDropdownOpen = function(day) {
        day = day.toISOString().split('T')[0]
        return $scope.view.settingsDropdown[day]
    }

    function initGlobalConfig() {
        if (!$scope.state.data) {
            $scope.state.data = {}
        }
        if (!$scope.state.data.global) {
            $scope.state.data.global = {}
        }
        if (!$scope.state.data.global.config) {
            $scope.state.data.global.config = {}
        }
        if (!$scope.state.data.global.config.skipDays) {
            $scope.state.data.global.config.skipDays = []
        }
    }
    $scope.skipDay = function(day, type) {
        if (!$rootScope.isCustomer(showModal = true, source='Skip Day')) {
            return
        }
        day = day.toISOString().split('T')[0]
        console.log('Skip day', day)
        api.addSkipDays($scope.inputs.project, {
            day: day,
        }).then(function(response) {
            initGlobalConfig()
            $scope.state.data.global.config.skipDays.push(day)
            $timeout(angular.noop)
            if (type == 'replan') {
                $scope.planSchedulePost('replan')
            }
        }).catch(function(err) {
            console.log('Error skipping day', err)
        })
        track('Cal Skip Day', {day: day})
    }

    $scope.removeSkipDay = function(day) {
        if (!$rootScope.isCustomer(showModal = true)) {
            return
        }
        day = day.toISOString().split('T')[0]
        api.removeSkipDays($scope.inputs.project, {
            day: day,
        }).then(function(response) {
            initGlobalConfig()
            $scope.state.data.global.config.skipDays = $scope.state.data.global.config.skipDays.filter(skipDay => skipDay != day)
            $timeout(angular.noop)
        }).catch(function(err) {
            console.log('Error removing skip day', err)
        })
        track('Cal Remove Skip Day', {day: day})
    }

    $scope.isAvailableDay = function(day) {
        let availableDays = mapScheduleToDays[$scope.calendar.schedule.when]
        return availableDays.includes(day.value.getDay()) && !$scope.isSkipDay(day.value) && day.type != 'past' || (day.posts && day.posts.length > 0)
    }

    $scope.isSkipDay = function(day) {
        day = day.toISOString().split('T')[0]
        initGlobalConfig()
        return $scope.state.data.global.config.skipDays.includes(day)
    }

    $scope.savePostCalendar = function(postId, check) {
        if (typeof check === 'undefined' || check) {
            if (!$rootScope.isCustomer(showModal = true, source='Save Post Calendar')) {
                return
            }
        }
        let posts = []
        let post = $scope.posts[postId]
        let postCalendar = post.meta.calendar
        if (postCalendar) {
            delete postCalendar.week
            delete postCalendar.day
            if (postCalendar?.date) {
                postCalendar.scheduleAt = new Date(postCalendar.date).toISOString()
                postCalendar.localeScheduleAt = postCalendar.date.toString()
            }
        }
        posts.push({
            id: post._id,
            calendar: postCalendar,
        })

        if (posts.length > 0) {
            $rootScope.loading.calendar = true
            $scope.view.loading.savingReplan = true
            api.updateBulkCalendar({posts}).then(function(response) {
                // TODO - Success
                console.log('=> Updated posts', response)
            })
            .catch(function(err) {
                // TODO - Error
                console.log('Error updating posts', err)
            })
            .finally(function() {
                $rootScope.loading.calendar = false
                $scope.view.loading.savingReplan = false
                $timeout(angular.noop)
            })
        }
    }

    $scope.onDrop = function(postId, areaId) {
        let newDate = new Date(areaId)
        if (newDate < new Date()) {
            showError(gettext('error.calendar_drop_past'))
            return
        }
        if ($scope.posts[postId].meta.calendar.time) {
            let parts = $scope.posts[postId].meta.calendar.time.split(':')
            let hours = parseInt(parts[0])
            let minutes = parseInt(parts[1])

            newDate.setHours(hours)
            newDate.setMinutes(minutes)
            newDate.setSeconds(0)
            newDate.setMilliseconds(0)
        }
        $scope.posts[postId].meta.calendar.date = getLocaleDate(newDate)

        $scope.planSchedulePost()
        if (!$scope.posts[postId].meta.calendar.pinned) {
            $scope.favoritePost(postId)
        }

        $scope.savePostCalendar(postId)
        $timeout(angular.noop)
        track('Cal Drop Post', {postId: postId})
    }

    let refreshDebounce = null
    $scope.refreshCalendar = function() {
        if (refreshDebounce) {
            $timeout.cancel(refreshDebounce)
        }
        refreshDebounce = $timeout(function() {
            $scope.parsedPosts = $scope.posts.map(function(post, index) {
                return $scope.convertPostToParsedPost(post, index)
            })
            $timeout(angular.noop)
        }, 200)
    }

    $rootScope.$on('themeChanged', function(event, data) {
        $scope.refreshCalendar()
    })

    $rootScope.$on('globalChanged', function(event, data) {
        $scope.refreshCalendar()
    })

    $scope.init = function() {
        $scope.buildCalendar()
        layoutService.list().then(function(layouts) {
            $scope.layoutsConfig = JSON.parse(JSON.stringify(layouts))
            $scope.expandedLayouts = []
            // TASK [HP] Performance this is slow
            // TASK [HP] This is duplicated
            for (let layoutKey in $scope.layoutsConfig.layouts) {
                for (layout of layoutService.expand($scope.layoutsConfig.layouts[layoutKey], layoutKey, $scope.layoutsConfig.layouts)) {
                    $scope.expandedLayouts.push(layout)
                }
            }
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })

        document.addEventListener('click', function(event) {
            $timeout(() => {
                if ($scope.state.view.bulkEditorDropdown) {
                    $scope.state.view.bulkEditorDropdown = false
                }
                for (let key in $scope.view.removeDropdown) {
                    $scope.view.removeDropdown[key] = false
                }
                for (let key in $scope.view.settingsDropdown) {
                    $scope.view.settingsDropdown[key] = false
                }
            })
        }, false)

        //$scope.schedulePost()
    }

    $scope.schedulePost = function() {

        publishModal = angular.element('#publish-modal')

        publishModal.modal('show')

        $rootScope.postId = '_draft_'

        getEditor(function(editor) {
            $rootScope.$broadcast('publishContent', {
                text: 'Future of marketing',
                post: {
                    'data': {
                        'format': 'post'
                    }
                },
                type: 'publish',
                //source: 'source',
            })
        })

        // On hide broadcast publishContent
        publishModal.on('hidden.bs.modal', function (e) {
            $rootScope.$broadcast('publishHidden')
        })
    }
})
